// Action Types
export const VENDOR_REPORT_REQUEST = 'VENDOR_REPORT_REQUEST';
export const VENDOR_REPORT_SUCCESS = 'VENDOR_REPORT_SUCCESS';
export const VENDOR_REPORT_FAILURE = 'VENDOR_REPORT_FAILURE';
export const VENDOR_REPORT_RESET = 'VENDOR_REPORT_RESET';

// Initial State
const initialState = {
    data: [],
    summary: {
        totalInvoices: 0,
        avgResponse: 0,
        totalLates: 0,
        percentLate: 0
    },
    loading: false,
    error: null
};

// Reducer
export default function vendorReportReducer(state = initialState, action) {
    switch (action.type) {
        case VENDOR_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case VENDOR_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.invoice_data || [],
                summary: {
                    totalInvoices: action.payload.summary_data.total_invoices,
                    avgResponse: action.payload.summary_data.avg_response,
                    totalLates: action.payload.summary_data.total_lates,
                    percentLate: action.payload.summary_data.percent_late
                }
            };
            
        case VENDOR_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: [],
                summary: initialState.summary
            };

        case VENDOR_REPORT_RESET:
            return initialState;
            
        default:
            return state;
    }
}

// Action Creators
export const vendorReportRequest = () => ({
    type: VENDOR_REPORT_REQUEST
});

export const vendorReportSuccess = (data) => ({
    type: VENDOR_REPORT_SUCCESS,
    payload: data
});

export const vendorReportFailure = (error) => ({
    type: VENDOR_REPORT_FAILURE,
    payload: error
});

export const vendorReportReset = () => ({
    type: VENDOR_REPORT_RESET
});